import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="p-5">
            <h1 className="text-center my-5 fontSize48">Privacy Policy</h1>
            <h2 className='my-4'>General</h2>
            <p>
                We at the WiserBee Corp ("we" or "us") are committed to protecting the privacy of our
                users. Please review this Privacy Policy carefully to understand how the information you
                provide to us will be treated.
            </p>
            <p>
                This Privacy Policy applies to personal information collected at:
            </p>
            <ul>
                <li>wiserbee.ca Web sites and other sites that we own or control ("wiserbee Web sites"), including www.wiserbee.ca</li>
                <li>WiserBee enterprise offerings that may be hosted by wiserbee.ca or its third party service providers</li>
                <li>WiserBee Corp consumer offerings</li>
            </ul>
            <p>
                This Privacy Policy applies to domains and subdomains of Wiserbee.ca. There are two main classes
                of users of WiserBee offerings: enterprise users and consumer users. Enterprise users
                access WiserBee offerings by virtue of an agreement that we have with the user's
                institution (educational or otherwise), employer or other organization ("Organization").
                Consumer users are visitors to WiserBee Web sites, or persons who access WiserBee
                offerings by virtue of an agreement directly with us.
            </p>
            <p>
                If you were given access by an Organization as an enterprise user or as a parent or
                guardian of an enterprise user, this Privacy Policy does not affect or control the
                Organization's collection, use or disclosure of your information. You should contact your
                Organization to find out its practices regarding your personal information.
            </p>
            <h2 className='my-5 text-center font-bold'>Consent to WISERBEE Processing</h2>
            <h2 className='my-4'>Information about You</h2>
            <p>
                "Personal information" means any information about an individual who is either directly or
                indirectly identified by the information or could be reasonably identified by it. Personal
                information includes information that relates to:
            </p>
            <ul>
                <li>An individual's personal characteristics (e.g. gender, age, income, home address, personal phone number, identification number, location data, an online identifier, ethnic background, family status, etc.)</li>
                <li>Health (e.g. health history, health conditions, health services received, etc.)</li>
                <li>Activities and views (e.g. religion, politics, opinions expressed by the individual, etc.)</li>
            </ul>
            <p>
                This Privacy Policy does not apply to information we collect in the aggregate. Aggregated information does not
                identify you as an individual.
            </p>
            <p>
                By providing any Personal Information to us or sharing Personal Information with others
                (including sensitive information) using a WiserBee website, you expressly and voluntarily
                consent to the storage and processing of that Personal Information by us in accordance
                with the terms and conditions of this Privacy Policy and any applicable user agreement
                (including an end user license agreement or service agreement) that allows us to store
                and process Personal Information about you. When you provide information, that
                information may reside on our or our service providers' systems. You understand and
                agree that Personal Information collected through WiserBee Web sites may be stored
                and processed by us, our affiliates or our service providers in Canada, the United States,
                UK, GCC, Singapore or other countries, including countries other than your country of
                residence; the laws of the jurisdiction in which the information is stored and processed
                will apply to its storage and processing. If you are a user of WiserBee products and
                services, the location of your data and the laws that apply to its storage and processing
                may be subject to a contract between WiserBee and your Organization.
            </p>
            <h2 className='my-4'>Collection of Personal Information</h2>
            <p>We may collect personal information from you in the following ways:</p>
            <h3>REGISTRATION AND PROFESSIONAL SERVICES</h3>
            <p>
                In order to access some WiserBee offerings, you may be asked to create an account
                which will require you to provide us with information that may include your name and
                email address and other Personal Information. Certain WiserBee offerings enable you to
                provide additional information voluntarily. Providing information beyond what is required
                at registration is up to you, but providing such information may enable you to derive more
                benefit from WiserBee offerings.
            </p>
            <p>
                We may collect Personal Information about you if your Organization has contracted with
                us for professional services or end-user support, or if you are an approved support contact
                under our agreement with your Organization. This information may include your name,
                email address or other Personal Information. Information collected in connection with our
                provision of professional services to your Organization is collected for the purpose of
                providing such services to your Organization efficiently and effectively. Information
                collected through the use of our support service is intended to help resolve issues as
                quickly as possible, and to ensure that you can be notified of the progress of any issues
                that you describe.
            </p>
            <p>
                We may collect Personal Information about you if you contact us by email or for support
                for a WiserBee consumer offering.
            </p>
            <h3>WEB SITES, ECOMMERCE AND OTHER MARKETING INITIATIVES</h3>
            <p>
                At WiserBee Web sites, we ask you to provide Personal Information, such as your email
                address, name, employer name, home or work address, or telephone number. We may
                also collect demographic information, such as your postal or zip code, gender, age,
                preferences, interests and favorites.
            </p>
            <p>
                We may collect Personal Information from you such as your name, email address,
                telephone number and Organization information when you sign up for webinars, product
                trials, newsletters, contests or other marketing initiatives through WiserBee Web sites.
            </p>
            <p>
                If you make a purchase through a WiserBee or other WiserBee offering or sign up for a
                conference or seminar, a paid subscription service or a consumer offering, we or our third
                party providers may ask for additional information, such as your credit card information,
                billing address or shipping address.
            </p>
            <p>
                When you join, or post information to, one of our communities, you share your profile
                information, including your name and other information that you choose to share, with
                other community members. When you submit an application or inquiry through our
                Careers site, you voluntarily provide Personal Information to us.
            </p>
            <p>
                When you post a comment on our company blog, you share information within your
                comment, along with the name you provide, with the general public.
            </p>
            <h3>COOKIES AND WEB BEACONS</h3>
            <p>
                Like most web sites, we use technologies, such as cookies and web beacons, to collect
                information about the pages you view, the links you click and other actions you take in
                using WiserBee offerings and WiserBee Web sites. More information regarding our use
                of cookies can be found here: <a href="https://www.wiserbee.ca/legal/cookies-policy/">https://www.wiserbee.ca/legal/cookies-policy/</a>.
            </p>
            <h3>INFORMATION COLLECTED BY YOUR ORGANIZATION OR THIRD PARTIES</h3>
            <p>
                If you are an enterprise user, your Organization may collect information on its own through
                the use of WiserBee offerings. Collection and use of information in this way is governed
                by the privacy policies of your Organization.
            </p>
            <h2 className='my-4'>ANALYTICS</h2>
            <p>
                We use tools to help us analyze how WiserBee offerings and WiserBee Web sites are
                used, and to help us develop and optimize our WiserBee offerings and WiserBee Web
                sites. We also use Google Analytics to improve our offerings and our Web sites.
                See <a href="http://www.google.com/analytics/terms/us.html">http://www.google.com/analytics/terms/us.html</a> for more information about Google
                Analytics.
            </p>
            <h2 className='my-5 font-bold text-center'>Use of Personal Information</h2>
            <h3>HOW WE USE YOUR INFORMATION</h3>
            <p>If you are an enterprise user:</p>
            <p>
                Your Organization may use information that it has collected through the use of WiserBee
                or other WiserBee offerings in a manner that is different from what is set out in this Privacy
                Policy. Any use of your information by your Organization is subject to the privacy policies
                of your Organization.
            </p>
            <p>
                If your Organization is a school in the United States, our provision of services may involve
                us having access to student education records subject to the US Family Educational
                Rights and Privacy Act (FERPA), 20 U.S.C. 1232g, et seq. Under FERPA, we are deemed
                a "school official" to the extent we have access to student education records, and we will
                not use such student education records for any purpose other than to perform our
                agreements with you or as otherwise mandated by applicable regulations.
            </p>
            <p>
                Beyond the Personal Information that you directly provide to use WiserBee products and
                services, we infer Personal Information based on your usage. Monitoring information
                such as IP Addresses, the date/time of actions being taken, and what features are being
                used help us deliver great experiences. For example, having a historical record of the
                number of logins that occur over the months of August and September assists us in
                making sure our systems are ready during the typical semester start period of North
                America. WiserBee analyzes this type of data in aggregate and does not sell this
                information to third parties.
            </p>
            <p>If you are a consumer user:</p>
            <p>
                We may use your information to communicate with you. We may send certain service
                communications such as welcome letters, billing reminders, information on technical
                service issues, and security announcements. Some WiserBee offerings may send periodic member letters that are considered part of the service. We may also send you
                promotional information to inform you of other WiserBee offerings and promotions.
            </p>
            <p>
                We use your information to operate and improve WiserBee offerings and WiserBee Web
                sites. These uses include providing you with more effective customer service, making
                WiserBee offerings easier to use by eliminating the need for you to enter or repeatedly
                enter the same information, performing research and analysis aimed at improving
                WiserBee offerings and WiserBee Web sites, and displaying content and advertising that
                are customized to your interests and preferences.
            </p>
            <p>
                Some WiserBee offerings are accompanied by interactive features such as chat rooms,
                forums, messaging and other ways to share. If you are an enterprise user, permissions
                as to what features are enabled and who has access to those features is determined by
                your Organization. If you are a consumer user, it is your choice whether to use the
                available functionalities.
            </p>
            <p>
                If you submit information through a WiserBee Web site, Personal Information you submit
                may be used to provide the WiserBee or other WiserBee offerings that you requested,
                and may also be used for activities related to the purpose for which you've submitted the
                information.
            </p>
            <p>
                When you receive newsletters or promotional emails from us, we may use web beacons,
                customized links or similar technologies to determine whether the email has been opened
                and which links you click in order to provide you more focused e-mail communications or
                other information.
            </p>
            <h2 className='my-4'>Communications We Send</h2>
            <p>
                We may communicate with you through email or other means available through a
                WiserBee offering. We may send emails that help inform you about features of WiserBee
                offerings and we may also send you service messages related to the function of WiserBee
                offerings. We may send you messages with promotional information directly or on behalf
                of our partners.
            </p>
            <p>
                If you sign up for webinars, product trials, newsletters, our annual global conference,
                contests, mailing lists or other marketing initiatives through the WiserBee Web sites,
                employees of WiserBee may contact you with information about WiserBee offerings and
                promotions that may be of interest to you. We may offer Webinars, product trials,
                conferences and events, contests or other marketing initiatives with certain partners; in
                such cases, the information you submit upon sign-up is shared with the relevant
                partner(s).
            </p>
            <h2 className='my-4'>Sharing Your Information with Third Parties</h2>
            <p>
                We may share your information with third parties who are not our partners or service
                providers only in the following situations:
            </p>
            <ul>
                <li>We have your consent through an opt-in option provided to you; or</li>
                <li>We have a good faith belief that access, use, preservation or disclosure of your
                    Personal Information is reasonably necessary to:
                    <ul>
                        <li>Satisfy any applicable law, regulation, legal process or enforceable governmental request,</li>
                        <li>enforce applicable terms and conditions of this Privacy Policy or any applicable user agreement, including investigation of potential violations thereof,</li>
                        <li>detect, prevent, or otherwise address fraud, security or technical issues, or</li>
                        <li>protect against harm to the rights, property or safety of us, our users or the public as required or permitted by law.</li>
                    </ul>
                </li>
            </ul>
            <p>
                As may be necessary in the course of providing our product offerings to you, we may
                disclose information to the payment processors, auditors, commercial partners, customer
                support providers, marketing and public relations companies, and operational services
                providers.
            </p>
            <h3>Mergers or Acquisitions</h3>
            <p>
                As with any other business, it is possible that in the future,
                WiserBee could merge with, or be acquired by, another company. If such an acquisition
                occurs, you consent to the successor company having access to the information
                maintained by WiserBee, and such successor company would continue to be bound by
                this Privacy Policy unless and until it is amended.
            </p>
            <p>
                Except as part of the sale of all or substantially all of our assets, we will not sell, trade, or
                rent your Personal Information to third parties who are not our partners or service
                providers unless we have your consent.
            </p>
            <h2 className='my-4'>Information You Share With Other Users</h2>
            <p>
                WiserBee offerings may enable you to share information with or send communications to
                other users or the general public. You (or, if you are an enterprise user, your Organization)
                may select the other users with whom you share or to whom you send this information.
                Once you share information with or send information to other users, however, those other
                users may share your information at their discretion.
            </p>
            <h2 className='my-5 font-bold text-center'>Your Options for Your Personal Information</h2>
            <h3>Accessing and Correcting Your Personal Information</h3>
            <p>
                We offer users the ability to access or correct information we collect during registration or
                which they have provided in using WiserBee offerings. Users may correct this information
                at any time and as often as necessary by using the features provided within the applicable
                WiserBee offering. To access or correct Personal Information collected by us that is not
                available through a WiserBee offering, please contact us at the address listed below. We
                will respond within a reasonable timeframe of receiving your request or as otherwise
                required by law.
            </p>
            <p>
                We may decline to provide you with access to, or to change, your Personal Information if
                (a) your request is not provided in writing, (b) your request does not provide us with
                sufficient detail to identify the Personal Information you seek to access or change, (c) we
                are unable to verify your identity to our satisfaction, (d) we deem, in our sole discretion,
                that it would be unreasonable in the circumstances to provide you with access to or to
                correct your Personal Information, or (e) as otherwise provided by legislation.
            </p>
            <p>
                If you are an enterprise user, you should contact your Organization for questions about
                access to the Personal Information collected by your Organization.
            </p>
            <h3>User Opt-Out Option and Retention of Your Information</h3>
            <p>
                You may opt out of receiving promotional information from us by following the unsubscribe
                procedures indicated in promotional information you receive.
            </p>
            <p>
                Please note that if you do not provide express consent, we may, in limited circumstances,
                continue to provide communications to you under implied consent provisions of applicable
                anti-spam legislation.
            </p>
            <p>
                If you are an enterprise user, retention of your Personal Information is the responsibility
                of your Organization and is governed by its privacy policies. If you wish to remove your
                account, please contact your Organization. If your Organization retains the information,
                it is subject to our contractual arrangement with your Organization and may be subject to
                our archival policies.
            </p>
            <p>
                If you are a consumer user, we will retain your Personal Information for so long as you
                maintain an active account or user profile, or as needed to provide you with the applicable 
                WiserBee offering.
            </p>
            <p>
                If you are a consumer user and you wish to remove or restrict the collection of data with
                an account you have with us, you may do so by contacting us at AskUs@wiserbee.ca
            </p>
            <p>
                We will retain and use your information as necessary to comply with our legal obligations,
                resolve disputes, and enforce this Privacy Policy and any applicable user agreements.
            </p>
            <p>
                We will take steps to ensure that your Personal Information is destroyed, erased or made
                anonymous as soon as the purpose for which it was collected is no longer relevant, or as
                required by law.
            </p>
            <p>
                Please be aware that, as long as you have access to WiserBee offerings, you cannot opt
                out of receiving service messages from us. Also, if we send communications to you via
                the carrier service with which you have a mobile communications subscription or
                otherwise have access, you understand you will pay any service fees associated with
                your receipt of messages on your mobile device (including text messaging charges).
            </p>
            <h2 className='my-4'>Information Security</h2>
            <p>
                At WiserBee, the security and protection of data is a core priority. We maintain stringent
                security practices and have earned multiple security certifications to ensure a secure
                environment for all information entrusted to us.
            </p>
            <p>
                We take appropriate security measures to protect against unauthorized access, unauthorized
                alteration, disclosure, or destruction of data. These measures include internal reviews of our
                data collection, storage, and processing practices, as well as rigorous security measures,
                including encryption, access control, and physical safeguards. We leverage industry-leading
                cloud service providers — Amazon Web Services (AWS) and Google Cloud Platform (GCP) — to
                host and manage our systems, ensuring the highest standards of reliability, scalability, and
                security.
            </p>
            <p>
                For further details about our security framework and certifications, please
                visit: <a href="https://www.wiserbee.ca/security/compliance/">www.wiserbee.ca/security/compliance/</a>.
            </p>
            <p>
                Access to Personal Information is strictly limited to WiserBee employees, contractors, and
                agents who require it to perform their job duties. All such individuals are bound by strict
                confidentiality obligations and are subject to disciplinary actions — up to and including
                termination, civil liability, and criminal prosecution — for any breaches.
            </p>
            <p>
                While WiserBee takes robust steps to protect your data, no system is entirely immune to risks.
                Therefore, we cannot guarantee absolute protection against unauthorized access, loss, misuse,
                or alteration of Personal Information stored on our or our service providers' platforms.
            </p>
            <h3>Your Responsibilities:</h3>
            <p>
                You are responsible for maintaining the confidentiality and security of your passwords and
                credentials, and for ensuring secure access to the WiserBee offerings made available to you.
            </p>
            <h3>For Enterprise Clients:</h3>
            <p>
                If you are an enterprise user, your organization is responsible for configuring system settings
                appropriately to ensure restricted access to information, consistent with your own internal
                privacy policies and obligations. Furthermore, the organization must ensure that any individuals
                granted access are governed by these privacy policies.
            </p>
            <h2 className='my-4'>Protection of Children's Personal Information</h2>
            <p>
                If you are an enterprise user, your Organization may collect information on its own through
                the use of WiserBee offerings. Collection of information in this way is at your
                Organization's discretion and is governed by the privacy policies of your Organization.
                WiserBee offerings contain configuration options that your Organization may use to align
                the WiserBee offerings with Organization policies.
            </p>
            <p>
                We do not knowingly collect any Personal Information from individuals under the age of
                13 through WiserBee consumer offerings or WiserBee Web sites. The WiserBee Web
                sites are general audience Web sites.
            </p>
            <h2 className='my-4'>Data Transfers</h2>
            <p>
                To the extent that we store data with third party providers, we and our service providers
                comply with the relevant data transfer principles governing such transfers, and Canada's
                Personal Information Protection and Electronic Documents Act (PIPEDA). In order to
                adequately protect data transfers originating from the EU, we will ensure that the country
                to which the data is transferred is approved by the European Commission as having a
                sufficient level of privacy protection, or we will use approved standard contractual model
                clauses. If you reside in the European Union, upon registration for any applicable WiserBee
                offering, you consent that the Personal Information you have provided may be transferred
                and stored in countries outside the EU.
            </p>
            <h2 className='my-4'>GDPR</h2>
            <p>
                The European Union's General Data Protection Regulation (GDPR) entered into force on
                25 May 2018. The GDPR protects European Union data subjects' fundamental right to
                privacy and the protection of personal data.
            </p>
            <p>
                For an overview of the rights that are given to individuals and how it may affect WiserBee
                customers using WiserBee, please consult our GDPR page.
            </p>
            <p>
                WiserBee complies with the GDPR and you have the right to lodge a complaint with a
                supervisory authority in relation to the processing of your personal data if it is not in
                compliance with the GDPR.
            </p>
            <h2 className='my-4'>Changes to this Privacy Policy</h2>
            <p>
                We keep our Privacy Policy under regular review. We reserve the right to modify or
                supplement this Privacy Policy at any time. If we make a change to this Privacy Policy,
                we will post such changes on our website.
            </p>
            <h2 className='my-4'>How to Contact Us</h2>
            <p>
                We commit to the resolution of questions or concerns about your privacy and our
                collection or use of your Personal Information.
            </p>
            <p>
                Our Privacy Officer/Data Protection Officer is responsible for ensuring our compliance
                with this Privacy Policy and all relevant privacy laws.
            </p>
            <p>
                If you have any comments, questions or concerns about this Privacy Policy, the data that
                we collect from you or how that data is being used, or to report suspected misuse of your
                information, please contact us at Privacy@wiserbee.ca or write to us at:
            </p>
            <h5 className='font-bold'>
                WiserBee Corporation<br />
                Attn: Privacy Officer<br />
                520 Caverhill Cres<br />
                Milton, ON L9T5K2<br />
                cc: Legal Department
            </h5>
        </div>
    );
};

export default PrivacyPolicy;